module.exports = __webpack_public_path__ + "9390229c.svg";